<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { InfoIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .insertBelow(({ escapeList: true, onlyIfEmpty: true }))
    .toggleCallout()
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="InfoIcon"
    @click="run"
    @keydown.enter="run"
  >
    Callout
  </SuggestionListItem>
</template>
